export function useHasSocks(): boolean | undefined {
  return false
}
